import { Stats } from "@flakiness/server/common/stats/stats.js";
import { createFakeCommit, WireTypes } from "@flakiness/server/common/wireTypes.js";

export class CommitRegistry {
  private _commits = new Map<Stats.CommitId, WireTypes.Commit>();

  addCommits(commits: WireTypes.Commit[]) {
    for (const commit of commits)
      this._commits.set(commit.commitId, commit);
  }

  commit(commitId: Stats.CommitId) {
    return this._commits.get(commitId);
  }

  clear() {
    this._commits.clear();
  }

  commitOrFake(commitId: Stats.CommitId) {
    return this._commits.get(commitId) ?? createFakeCommit(commitId);
  }
}
